(function () {
  'use strict';
  function setup(root) {
    root.querySelectorAll('[data-ib-media-accordion]').forEach(function (accordion) {
      if (accordion.dataset.keyboardReady) return;
      accordion.dataset.keyboardReady = 'true';
      var triggers = Array.from(accordion.querySelectorAll('summary'));
      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowDown') next = (index + 1) % triggers.length;
          else if (event.key === 'ArrowUp') next = (index - 1 + triggers.length) % triggers.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = triggers.length - 1;
          else return;
          event.preventDefault();
          triggers[next].focus();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(document); });
  else setup(document);
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();
